import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// redux
import { createPassenger } from 'redux/passengers/operations';
// hooks
import { useAuth, useCities, useDate } from 'hooks';
// helpers
import { getFilteredCitiesList } from 'helpers';
// components
import Input from 'components/Form/Input';
import Textarea from 'components/Form/Textarea';
import Datepicker from 'components/Datepicker/Datepicker';
// scss
import 'components/forms/PassengerForms/PassengerForms.scss';

const PassengerAddForm = ({ closeModal }) => {
  const [nameValue, setNameValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [departurePointValue, setDeparturePointValue] = useState('');
  const [arrivalPointValue, setArrivalPointValue] = useState('');
  const [departureDateValue, setDepartureDateValue] = useState('');
  const [returnDateValue, setReturnDateValue] = useState('');
  const [numberOfTicketsValue, setNumberOfTicketsValue] = useState('');
  const [ticketPriceValue, setTicketPriceValue] = useState('');
  const [seatsValue, setSeatsValue] = useState('');
  const [commentValue, setCommentValue] = useState('');
  const [ticketStatusValue, setTicketStatusValue] = useState("booked");
  const [creatorNameValue, setCreatorNameValue] = useState('');
  const [filteredCitiesList, setFilteredCitiesList] = useState(null);
  const [departurePointActive, setDeparturePointActive] = useState(false);
  const [arrivalPointActive, setArrivalPointActive] = useState(false);
  const [departureDateActive, setDepartureDateActive] = useState(false);
  const [returnDateActive, setReturnDateActive] = useState(false);
  const dispatch = useDispatch();
  const { isSuperAdmin } = useAuth();
  const { cities } = useCities();
  const { todayJSON } = useDate();

  function onChange(e) {
    switch (e.target.name) {
      case 'name':
        setNameValue(e.target.value);
        break;
      case 'phone':
        setPhoneValue(e.target.value);
        break;
      case 'number_of_tickets':
        setNumberOfTicketsValue(e.target.value);
        break;
      case 'ticket_price':
        setTicketPriceValue(e.target.value);
        break;
      case 'seats':
        setSeatsValue(e.target.value);
        break;
      case 'comment':
        setCommentValue(e.target.value);
        break;
      case 'creator_name':
        setCreatorNameValue(e.target.value);
        break;
      case 'ticket_status':
        setTicketStatusValue(e.target.value);
        break;

      default:
        return;
    }
  }

  function onInput(e) {
    const filteredDataList = getFilteredCitiesList(cities, e.target.value?.trimStart());
    setFilteredCitiesList(filteredDataList);

    switch (e.target.name) {
      case 'departure_point':
        setDeparturePointValue(e.target.value);
        setArrivalPointActive(false);
        setDeparturePointActive(true);
        break;
      case 'arrival_point':
        setArrivalPointValue(e.target.value);
        setDeparturePointActive(false);
        setArrivalPointActive(true);
        break;

      default:
        return;
    }
  }

  function onClickSetCity(value, inputName) {
    switch (inputName) {
      case 'departure_point':
        setDeparturePointValue(value);
        break;
      case 'arrival_point':
        setArrivalPointValue(value);
        break;

      default:
        return;
    }

    setFilteredCitiesList(null);
    setDeparturePointActive(false);
    setArrivalPointActive(false);
  }

  function onClickDateInput(inputName) {
    switch (inputName) {
      case 'departure_date':
        setDepartureDateActive(true);
        setReturnDateActive(false);
        break;
      case 'return_date':
        setReturnDateActive(true);
        setDepartureDateActive(false);
        break;

      default:
        return;
    }
  }

  // Функція для перетворення дати з формату YYYY-MM-DD у DD.MM.YYYY
  function formatDateForInput (dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}.${month}.${year}`;
  };

  function onClickSetDate(data) {
    switch (data?.inputName) {
      case 'departure_date':
        setDepartureDateValue(data?.startDay);

        const dateS = new Date(data?.startDay);
        const dateR = new Date(returnDateValue);
        if (dateR <= dateS) {
          setReturnDateValue('');
        }

        break;
      case 'return_date':
        setReturnDateValue(data?.startDay);
        break;

      default:
        return;
    }

    setDepartureDateActive(false);
    setReturnDateActive(false);
  }

  function onKeyPress(e) {
    let regex = '';
    switch (e.target.name) {
      case 'name':
        regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'\s]+$/u;
        break;
      case 'phone':
        regex = /[0-9+\- ]/;
        break;
      case 'number_of_tickets':
        regex = /[0-9]/;
        break;
      case 'ticket_price':
        regex = /[0-9]/;
        break;

      default:
        return;
    }

    const char = String.fromCharCode(e.charCode);
    if (!regex.test(char)) {
      e.preventDefault();
    }
  }

  function onSubmit(e) {
    e.preventDefault();
    const form = e.target;

    const data = {
      full_name: form?.elements.name?.value?.trim(),
      phone: form?.elements.phone?.value?.trim(),
      departure_point: form?.elements.departure_point?.value?.trim(),
      arrival_point: form?.elements.arrival_point?.value?.trim(),
      departure_date: form?.elements.departure_date?.value?.trim(),
      return_date: form?.elements.return_date?.value?.trim() || null,
      number_of_tickets: Number(form?.elements.number_of_tickets?.value),
      ticket_price: Number(form?.elements.ticket_price?.value),
      seats: form?.elements.seats?.value?.trim() || null,
      comment: form?.elements.comment?.value?.trim() || null,
      creator_name: form?.elements.creator_name?.value?.trim() || null,
      ticket_status: form?.elements.ticket_status?.value?.trim(),
    }
    
    dispatch(createPassenger(data));
    closeModal();
  }

  // function resetForm() {
  //   setNameValue('');
  //   setPhoneValue('');
  //   setPasswordValue('');
  //   // setNameDirty(false);
  //   // setPhoneDirty(false);
  //   // setPasswordDirty(false);
  //   // setNameError(null);
  //   // setPhoneError(null);
  // }

  return (
    <div className='passenger-form__wrap'>
      <h2 className="passenger-form__title">Додати нового пасажира</h2>
      <button className='passenger-form__btn-close' type='button' onClick={() => closeModal()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M0.286523 13.3301C-0.0955078 13.7121 -0.0955078 14.3314 0.286523 14.7135C0.668555 15.0955 1.28796 15.0955 1.67 14.7135L0.286523 13.3301ZM8.19171 8.19171C8.57376 7.80967 8.57376 7.19036 8.19171 6.80832C7.80967 6.42627 7.19036 6.42627 6.80832 6.80832L8.19171 8.19171ZM6.80832 6.80832C6.42627 7.19036 6.42627 7.80967 6.80832 8.19171C7.19036 8.57376 7.80967 8.57376 8.19171 8.19171L6.80832 6.80832ZM14.7135 1.67C15.0955 1.28797 15.0955 0.668555 14.7135 0.286523C14.3314 -0.0955078 13.7121 -0.0955078 13.3301 0.286523L14.7135 1.67ZM8.19171 6.80832C7.80967 6.42627 7.19036 6.42627 6.80832 6.80832C6.42627 7.19036 6.42627 7.80967 6.80832 8.19171L8.19171 6.80832ZM13.3301 14.7135C13.7121 15.0955 14.3314 15.0955 14.7135 14.7135C15.0955 14.3314 15.0955 13.7121 14.7135 13.3301L13.3301 14.7135ZM6.80832 8.19171C7.19036 8.57376 7.80967 8.57376 8.19171 8.19171C8.57376 7.80967 8.57376 7.19036 8.19171 6.80832L6.80832 8.19171ZM1.67 0.286523C1.28796 -0.0955078 0.668555 -0.0955078 0.286523 0.286523C-0.0955078 0.668555 -0.0955078 1.28797 0.286523 1.67L1.67 0.286523ZM1.67 14.7135L8.19171 8.19171L6.80832 6.80832L0.286523 13.3301L1.67 14.7135ZM8.19171 8.19171L14.7135 1.67L13.3301 0.286523L6.80832 6.80832L8.19171 8.19171ZM6.80832 8.19171L13.3301 14.7135L14.7135 13.3301L8.19171 6.80832L6.80832 8.19171ZM8.19171 6.80832L1.67 0.286523L0.286523 1.67L6.80832 8.19171L8.19171 6.80832Z" fill="black"/>
        </svg>
      </button>
      <form className="passenger-form" id="passengerAddForm" name="passengerAddForm" onSubmit={onSubmit} >
        <label className="label">
          <span> ПІБ Пасажира*</span>
          <Input
            name="name"
            placeholder="Катерина Маляр"
            value={nameValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            required={true}
            minLength={3}
            maxLength={150}
          />
        </label>
        <label className="label">
          <span>Номер телефону*</span>
          <Input
            type="tel"
            name="phone"
            placeholder="+380970000000"
            value={phoneValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            required={true}
            minLength={10}
            maxLength={13}
          />
        </label>
        <label className="label label--cities cities">
          <span>Пункт відправлення*</span>
          <Input
            className="input--city"
            name="departure_point"
            placeholder="Київ"
            value={departurePointValue}
            onInput={onInput}
            required={true}
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.68018 10.0427L9.12211 14.7776L12.5641 10.0427H5.68018Z" fill="#7D7D7D"/>
          </svg>
          {filteredCitiesList && departurePointActive && (
            <ul className='cities__list'>
              {filteredCitiesList?.map((i, idx) => (
                <li key={idx} className='cities__item' onClick={() => onClickSetCity(i, "departure_point")}>{i}</li>
              ))}
            </ul>
          )}
        </label>
        <label className="label label--cities cities">
          <span>Місце призначення*</span>
          <Input
            className="input--city"
            name="arrival_point"
            placeholder="Рим"
            value={arrivalPointValue}
            onInput={onInput}
            required={true}
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.68018 10.0427L9.12211 14.7776L12.5641 10.0427H5.68018Z" fill="#7D7D7D"/>
          </svg>
          {filteredCitiesList && arrivalPointActive && (
            <ul className='cities__list'>
              {filteredCitiesList?.map((i, idx) => (
                <li key={idx} className='cities__item' onClick={() => onClickSetCity(i, "arrival_point")}>{i}</li>
              ))}
            </ul>
          )}
        </label>
        <label className="label label--calendar">
          <span>Дата поїздки*</span>
          <Input
            className="input--none"
            name="departure_date"
            placeholder="12.09.2024"
            value={departureDateValue}
            onChange={onChange}
            required={true}
            // disabled={true}
          />
          <button className='input-date__btn' type='button' onClick={() => onClickDateInput("departure_date")}>
            {departureDateValue ? formatDateForInput(departureDateValue) : <span>12.09.2024</span>}
          </button>
          <svg className='icon-calendar' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M1 7.11481H19.2778M5.06173 1.02222V3.05308M15.216 1.02222V3.05308M4.0463 10.1611H6.07716M9.12346 10.1611H11.1543M14.2006 10.1611H16.2315M4.0463 13.2074H6.07716M9.12346 13.2074H11.1543M14.2006 13.2074H16.2315M4.0463 16.2537H6.07716M9.12346 16.2537H11.1543M14.2006 16.2537H16.2315M4.24938 19.3H16.0284C17.1658 19.3 17.7345 19.3 18.1689 19.0786C18.551 18.884 18.8618 18.5733 19.0564 18.1911C19.2778 17.7567 19.2778 17.188 19.2778 16.0506V6.30246C19.2778 5.16507 19.2778 4.59638 19.0564 4.16195C18.8618 3.77982 18.551 3.46913 18.1689 3.27443C17.7345 3.05308 17.1658 3.05308 16.0284 3.05308H4.24938C3.112 3.05308 2.54329 3.05308 2.10887 3.27443C1.72673 3.46913 1.41605 3.77982 1.22135 4.16195C1 4.59638 1 5.16507 1 6.30246V16.0506C1 17.188 1 17.7567 1.22135 18.1911C1.41605 18.5733 1.72673 18.884 2.10887 19.0786C2.54329 19.3 3.11199 19.3 4.24938 19.3Z" stroke="#344054" strokeWidth="1.37083" strokeLinecap="round"/>
          </svg>
          {departureDateActive && <Datepicker inputName={"departure_date"} oneDate={true} startDayInit={departureDateValue} min={todayJSON} handleSetDate={onClickSetDate} handleCancel={() => setDepartureDateActive(false)} />}
        </label>
        <label className="label label--calendar">
          <span>В дві сторони </span>
          <Input
            className="input--none"
            name="return_date"
            placeholder="14.09.2024"
            value={returnDateValue}
            disabled={true}
            min={departureDateValue}
          />
          <button className='input-date__btn' type='button' onClick={() => onClickDateInput("return_date")} disabled={!departureDateValue}>
            {returnDateValue ? formatDateForInput(returnDateValue) : <span>14.09.2024</span>}
          </button>
          <svg className='icon-calendar' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M1 7.11481H19.2778M5.06173 1.02222V3.05308M15.216 1.02222V3.05308M4.0463 10.1611H6.07716M9.12346 10.1611H11.1543M14.2006 10.1611H16.2315M4.0463 13.2074H6.07716M9.12346 13.2074H11.1543M14.2006 13.2074H16.2315M4.0463 16.2537H6.07716M9.12346 16.2537H11.1543M14.2006 16.2537H16.2315M4.24938 19.3H16.0284C17.1658 19.3 17.7345 19.3 18.1689 19.0786C18.551 18.884 18.8618 18.5733 19.0564 18.1911C19.2778 17.7567 19.2778 17.188 19.2778 16.0506V6.30246C19.2778 5.16507 19.2778 4.59638 19.0564 4.16195C18.8618 3.77982 18.551 3.46913 18.1689 3.27443C17.7345 3.05308 17.1658 3.05308 16.0284 3.05308H4.24938C3.112 3.05308 2.54329 3.05308 2.10887 3.27443C1.72673 3.46913 1.41605 3.77982 1.22135 4.16195C1 4.59638 1 5.16507 1 6.30246V16.0506C1 17.188 1 17.7567 1.22135 18.1911C1.41605 18.5733 1.72673 18.884 2.10887 19.0786C2.54329 19.3 3.11199 19.3 4.24938 19.3Z" stroke="#344054" strokeWidth="1.37083" strokeLinecap="round"/>
          </svg>
          {returnDateActive && <Datepicker inputName={"return_date"} oneDate={true} startDayInit={returnDateValue} min={departureDateValue} handleSetDate={onClickSetDate} handleCancel={() => setReturnDateActive(false)} />}
        </label>
        <label className="label">
          <span>Кількість квитків*</span>
          <Input
            type="number"
            name="number_of_tickets"
            placeholder="1"
            value={numberOfTicketsValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            required={true}
            min={1}
            max={10}
          />
        </label>
        <label className="label label--ticket-status">
          <span>Вартість квитка*</span>
          <Input
            type="number"
            name="ticket_price"
            placeholder="150€"
            value={ticketPriceValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            required={true}
            min={0}
            max={9999}
          />
          <select className="ticket-status" name="ticket_status" value={ticketStatusValue} onChange={onChange} >
            <option value="booked">Заброньовано</option>
            <option value="paid">Оплачено</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.68018 10.0427L9.12211 14.7776L12.5641 10.0427H5.68018Z" fill="#7D7D7D"/>
          </svg>
        </label>
        <label className="label">
          <span>Місце</span>
          <Input
            name="seats"
            placeholder="3, 4"
            value={seatsValue}
            onChange={onChange}
            maxLength={40}
          />
        </label>
        <label className="label">
          <span>Коментар</span>
          <Textarea
            name="comment"
            placeholder="Ваш текст"
            value={commentValue}
            onChange={onChange}
            maxLength={240}
          />
        </label>
        {isSuperAdmin && 
        <label className="label" style={{"--items": 1}}>
          <span>Від кого</span>
          <Input
            name="creator_name"
            placeholder="Від кого"
            value={creatorNameValue}
            onChange={onChange}
            maxLength={40}
          />
        </label>
        }
        <div className="passenger-form__btn-wrap">
          <button type='submit' className='passenger-form__btn passenger-form__btn--submit'>
            Додати пасажира
          </button>
          <button type='button' className='passenger-form__btn passenger-form__btn--cancel' onClick={() => closeModal()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
              <path d="M6.51855 1L1.51855 6L6.51855 11" stroke="#B79A5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Назад
          </button>
        </div>
      </form>
    </div>
  );
};

export default PassengerAddForm;
